// extracted by mini-css-extract-plugin
module.exports = {"footerBg":"a","footerTopLinks":"b","footerFeedback":"c","footerSocial":"d","footerLegalLinks":"e","footerIconCards":"f","footerBotCopy":"g","screenReadersOnly":"h"};